import { Button, Drawer, Icon } from "@monta/design-system";
import { ArrowRight } from "@monta/icons";
import { fixString } from "@monta/router-js";
import type { TUtils } from "@monta/utils";
import { useState } from "react";
import type { IMenu } from "../../constants";
import Menu from "./Menu/Menu";
import Profile from "./actions/afterLogin/profile/Profile";
import LoginButton from "./actions/beforLogin/loginButton/LoginButton";
import CartIcon from "./actions/shared/cartIcon/CartIcon";
import styles from "./headerMobile.module.scss";
import ShopNav from "./shopNav";

interface HeaderMobileProps {
  menuItems: IMenu[];
  route: string;
  auth: TUtils["auth"];
  api: TUtils["api"];
  cart: TUtils["cart"];
}

const HeaderMobile = (props: HeaderMobileProps) => {
  const { menuItems, auth, cart } = props;
  const loginInfo = auth.useAuth();
  const [openDrawer, setOpenDrawer] = useState(false);

  if (typeof window !== "undefined") {
    const url = window.location.href;
    // TODO: rewrite code
    if (url.includes("exam-management")) {
      return (
        <div className={styles["header-mobile"]}>
          <ArrowRight
            className={styles["header-mobile__button"]}
            size={20}
            onClick={() => {
              if (url.includes("school")) {
                auth.redirectToDefault();
              } else
                window.location.href = fixString(
                  "/dashboard",
                  "APPLICATION_URL"
                );
            }}
          />
          <h1 className={styles["header-mobile__title"]}>مدیریت آزمون</h1>
        </div>
      );
    }
    if (url.includes("exam-results")) {
      return (
        <div className={styles["header-mobile"]}>
          <ArrowRight
            className={styles["header-mobile__button"]}
            size={20}
            onClick={() => {
              window.history.back();
            }}
          />
          <h1 className={styles["header-mobile__title"]}>کارنامه</h1>
        </div>
      );
    }
    if (url.includes("online-self-exam-generator")) {
      return (
        <div className={styles["header-mobile"]}>
          <ArrowRight
            className={styles["header-mobile__button"]}
            size={20}
            onClick={() => {
              window.history.back();
            }}
          />
          <h1 className={styles["header-mobile__title"]}>خودآزمایی آنلاین</h1>
        </div>
      );
    }
  }

  return (
    <div className={styles["header-mobile"]}>
      <div className={styles["header-mobile__menu-and-cart"]}>
        <Icon
          icon={"mi-navigation-menu-24px"}
          size={2}
          className={styles["header-mobile__menu-and-cart__menu"]}
          onClick={() => setOpenDrawer(!openDrawer)}
        />
      </div>
      <a
        href={fixString("/", "LANDING_URL")}
        className={styles["header-mobile__logo"]}
      >
        <img
          id="monta-logo"
          height={32}
          width={48}
          alt={"مٌـنتا، آموزش و ارزیابی هوشمند"}
          src={fixString("/montaLogo.png", "LANDING_URL")}
        />
      </a>
      <div className={styles["header-mobile__action"]}>
        <CartIcon cart={cart} />
        {loginInfo?.id ? <Profile auth={auth} /> : <LoginButton />}
      </div>

      <Drawer open={openDrawer} onclose={() => setOpenDrawer(!openDrawer)}>
        <div className={styles["drawer__header"]}>
          <div />
          <div className={styles["drawer__header__logo"]}>
            <Button
              width={"unset"}
              onClick={() => {
                if (auth?.isLoggedIn) {
                  auth?.redirectToDefault();
                } else
                  Object.assign(window.location, {
                    href: fixString("/", "LANDING_URL")
                  });
              }}
            >
              <img
                id="monta-logo"
                height={32}
                width={48}
                alt={"مٌـنتا، آموزش و ارزیابی هوشمند"}
                src={fixString("/montaLogo.png", "LANDING_URL")}
              />
            </Button>
          </div>
          <div className={styles["drawer__header__close"]}>
            <Icon
              icon={"mi-Wrong-answer"}
              size={1.5}
              onClick={() => {
                setOpenDrawer(!openDrawer);
              }}
            />
          </div>
        </div>
        <div className={styles["drawer__body"]}>
          {/* {Number(loginInfo?.typeId) == UsersTypeEnum.STUDENT ||
            (!loginInfo?.typeId && (
              <SearchIcon
                api={api}
                onCloseMobile={() => {
                  setOpenDrawer(!openDrawer);
                }}
              />
            ))} */}

          {/* {Boolean(loginInfo?.typeId) && (
            <div className={styles["drawer__body__action"]}>
              {Number(loginInfo?.typeId) !== UsersTypeEnum.STUDENT && (
                <div>
                  <Money loginInfo={loginInfo} />
                </div>
              )}
              {Number(loginInfo?.typeId) !== UsersTypeEnum.STUDENT && (
                <div className={styles["drawer__body__action--center"]}>
                  <Credit balanceReputation={loginInfo?.balance || 0} />
                </div>
              )}
              <div className={styles["drawer__body__action--end"]}>
                <NotificationsIcon />
              </div>
            </div>
          )} */}

          <Menu
            menuItems={menuItems}
            onCloseDrawer={() => setOpenDrawer(false)}
          />
          {loginInfo && loginInfo.id ? <></> : <ShopNav />}
        </div>
      </Drawer>
    </div>
  );
};

export default HeaderMobile;
